import React from 'react';
import { Text, Box, Stack } from '@nerdwallet/currency';

interface HomeValueProps {
  formattedHomeValue: string;
  formattedSuggestedPrice?: string;
}

export const HomeValue: React.FC<HomeValueProps> = (props) => {
  const { formattedHomeValue, formattedSuggestedPrice } = props;

  return (
    <Box>
      <Box paddingY={4} paddingX={3}>
        <Stack spacing={0}>
          <Text size="large" bold>
            {formattedHomeValue}
          </Text>
          {formattedSuggestedPrice && (
            <Text size="small">{`Suggested: ${formattedSuggestedPrice}`}</Text>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default HomeValue;
